import React, { useState, useEffect } from "react";
import { BsDiscord, BsTwitter, BsInstagram } from "react-icons/bs";
import logo from "./../assets/images/logo_original.png";

function Header() {
  const [sticky, setSticky] = useState(false);
  const [hidden, setHidden] = useState(true);
  // Add Background on scroll bottom
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10) setSticky(true);
      else setSticky(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {});
    };
  }, []);

  // Show Hide Navbar on Scroll
  window.onscroll = function (e) {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    scrollY <= this.lastScroll ? setHidden(true) : setHidden(false);
    this.lastScroll = scrollY;
  };

  return (
    <React.Fragment>
      <div
        className={`flex justify-around items-center h-20 fixed top-0 w-full z-50 ${
          sticky && "bg-black transition"
        } ${hidden ? "" : "hidden"}
        `}
      >
        <ul className="flex items-center w-60">
          <li className="mr-4 text-white hover:text-primary">
            <a href="#about">About</a>
          </li>
          <li className="mr-4 text-white hover:text-primary">
            <a href="#roadmap">Roadmap</a>
          </li>
          <li className="text-white hover:text-primary">
            <a href="#team">Team</a>
          </li>
        </ul>
        <div>
          <img src={logo} alt="mk logo" width="60" height="60" />
        </div>

        <ul className="items-center hidden md:flex w-60 ">
          <li className="ml-4 text-white hover:text-primary cursor-pointer">
            <BsDiscord />
          </li>
          <li className="ml-4 text-white hover:text-primary cursor-pointer">
            <BsTwitter />
          </li>
          <li className="ml-4 text-white hover:text-primary cursor-pointer">
            <BsInstagram />
          </li>
          {/* <li className="ml-4">
            <button class="bg-transparent hover:bg-primary text-primary font-semibold hover:text-white py-2 px-4 border-2 border-primary hover:border-transparent rounded-full">
              TO BAPEPES WEBSITE
            </button>
          </li> */}
        </ul>
      </div>
    </React.Fragment>
  );
}

export default Header;
